<template>
  <div class="container">
    <div class="page">
      <div @click="gotoPageQuestion(item.pageNumber)" :key="index"
           :class="{'page-item': true,'active':currentPage == item.pageNumber}"
           v-for="(item,index) in questionPageList">
        第{{ item.pageNumber }}页 {{ item.pageRemark }}
      </div>
    </div>
    <div class="question question-list" v-if="showList">

      <div style="width: 100%;height: 100%;position: relative;">
        <div v-if="questionList.length">
          <div v-for="(item,index) in questionList" :key="index" style="cursor: pointer">
            <question-single :patient-id="patientId" @setJump="setJump" @clearJump="clearJump"
                             :ref="item.id"
                             :question-list="questionList"
                             :displaySetting="item.displayNumber"
                             :jumpSetting="item.jumpNumber" v-if="item.type == 1"
                             :question="item"></question-single>
            <question-multiple :patient-id="patientId" :ref="item.id" :question-list="questionList"
                               :displaySetting="item.displayNumber"
                               :jumpSetting="item.jumpNumber" v-else-if="item.type == 2"
                               :question="item"></question-multiple>
            <question-drop-down :patient-id="patientId" :ref="item.id" :question-list="questionList"
                                :displaySetting="item.displayNumber"
                                :jumpSetting="item.jumpNumber" v-else-if="item.type == 3"
                                :question="item"></question-drop-down>
            <question-completion :patient-id="patientId" :ref="item.id" v-else-if="item.type == 4"
                                 :question="item"></question-completion>
            <question-time-select :questionList="questionList" :patient-id="patientId" :ref="item.id"
                                  v-else-if="item.type == 8"
                                  :question="item"></question-time-select>
            <question-para :patient-id="patientId" :ref="item.id" v-else-if="item.type == 6"
                           :question="item"></question-para>
            <question-scale :patient-id="patientId" @setJump="setJump" @clearJump="clearJump"
                            :ref="item.id"
                            :question-list="questionList"
                            :displaySetting="item.displayNumber"
                            :jumpSetting="item.jumpNumber" v-else-if="item.type == 9"
                            :question="item"></question-scale>
          </div>
        </div>
        <div v-else>
          <h1>题目已答完</h1>
        </div>
        <div v-if="!canEdit" class="cannotEditModel">

        </div>

      </div>
      <el-backtop target=".question-list" :bottom="100">
        <div
            style="{
          height: 100%;
          width: 100%;
          background-color: #f2f5f6;
          box-shadow: 0 0 6px rgba(0,0,0, .12);
          text-align: center;
          line-height: 40px;
          color: #1989fa;
        }"
        >
          <i class="el-icon-top"></i>
        </div>
      </el-backtop>

    </div>

  </div>
</template>
<script>
import questionSingle from './questionItemByType/question-single'
import questionMultiple from './questionItemByType/question-Multiple'
import questionDropDown from './questionItemByType/question-dropDown'
import questionTimeSelect from './questionItemByType/questionTimeSelect'
import questionCompletion from './questionItemByType/question-completion'
import questionPara from './questionItemByType/question-para'
import questionScale from './questionItemByType/question-scale'
import {
  RestNewFollowupQuestionListServicePreviewQuestionnaire,
  RestPatientAnswerInfoManagerControllerAddPatientAnswerInfo,
  RestNewFollowupQuestionListServiceGetQuestionnairePageList
} from "@src/assets/js/api.js"

export default {
  name: 'question-root-node',
  props: {
    followUpWay: {required: false},
    questionId: {required: false},
    patientId: {required: false},
    canEdit: {
      required: false,
      default() {
        return true
      }
    }
    // questionList: { required: true }
  },
  data() {
    return {
      questionListHistory: [],
      questionnaireNewId: "",
      showList: false,
      prevErrComponent: null,
      questionList: [],
      nextPage: null,
      prevPage: 0,
      pageHistoryList: [],
      statusId: null,
      questionPageList: [],
      currentPage: 1
    }
  },
  components: {
    questionSingle,
    questionMultiple,
    questionDropDown,
    questionTimeSelect,
    questionCompletion,
    questionPara,
    questionScale
  },
  mounted() {
    this.__init()
  },
  methods: {
    gotoPageQuestion(page) {
      console.log('qs', this.questionList);
      console.log(this.questionListHistory.find(item => item.page == this.currentPage));
      if (!this.questionListHistory.find(item => item.page == this.currentPage)) {
        this.cacheCurrentPage()
            .then(() => {
              this.getCacheQuestion(page)
            })
      } else {
        this.refreshCach(this.questionListHistory.find(item => item.page == this.currentPage))
            .then(() => {
              this.getCacheQuestion(page)
            })
      }
    },
    getCacheQuestion(page) {
      if (this.questionListHistory.find(item => item.page == page)) {
        console.log('cach', this.questionListHistory);
        this.questionList = this.questionListHistory.find(item => item.page == page).questionList
        this.currentPage = page
        this.pageHistoryList.push(page)
      } else {
        this.getQuestionList({
          taskId: this.questionId,
          pageNumber: page
        })
        this.pageHistoryList.push(page)
      }
    },
    refreshCach(history) {
      console.log('history', history);
      console.log(JSON.parse(JSON.stringify(this.questionList)));
      return new Promise(resolve => {
        history.questionList = JSON.parse(JSON.stringify(this.questionList))
        resolve()
      })
    },
    cacheCurrentPage(page) {
      console.log(JSON.parse(JSON.stringify(this.questionList)));
      return new Promise(resolve => {
        this.questionListHistory.push({
          page: this.currentPage,
          questionList: JSON.parse(JSON.stringify(this.questionList))
        })
        resolve()
      })
    },
    __init() {
      let params = {
        taskId: this.questionId,
        pageNumber: this.prevPage + 1
      }

      this.getQuestionList(params)

    },
    getQuestionList(p, callback = () => {
    }) {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.getQuestionByPageAndId(p)
          .then(res => {
            this.questionList = []
            if (res.retValue.questionInfoResp.length) {
              console.log("questionList===>", res.retValue)
              var questionList = res.retValue.questionInfoResp.map((item, index) => {
                var question = JSON.parse(JSON.stringify(this.questionHandle(item)))
                return question
              })
              this.$nextTick(() => {
                this.questionList = questionList
                this.nextPage = this.questionList[0].pageNumber + 1
                this.questionnaireNewId = this.questionList[0].questionnaireNewId
                this.getQuestionPage()

                var errorQuestion = questionList.filter(item => item.type == 6)
                if (errorQuestion.length == 1 && errorQuestion[0].title.indexOf('异常') != -1) {
                } else if (errorQuestion.length == 1 && errorQuestion[0].title.indexOf('最后') != -1) {
                }
                this.showList = true
                this.currentPage = p.pageNumber
              })
              callback()
            } else {
              this.$message.error(res.desc)
              // this.$store.dispatch('updatePateintQuestionAnswer', {
              //   finish: 0,
              //   followupPatientId: -1,
              //   id: this.statusId,
              //   questionnaireNewId: this.$route.query.id
              // })
              //   .then(res => {
              //     //console.log(res)
              //   })
              this.showList = true
            }
            loading.close()

          })
    },
    setJump(val) {
      this.nextPage = val
    },
    clearJump() {
      //console.log(111)
      this.nextPage = this.questionList[0].pageNumber + 1
    },

    questionHandle(question) {
      if (question.type) {
        question.completeConfig = question.completeConfig == '' ? {
          'completeTextArr': [{'text1': '', 'text2': ''}],
          'completeType': 'text',
          'maxLength': null
        } : JSON.parse(question.completeConfig)
        question.bingTimeId = question.bingTimeId ? JSON.parse(question.bingTimeId) : null
        question.timeConfigArr = question.timeConfigArr ? JSON.parse(question.timeConfigArr) : [{
          type: '',
          withBingId: '',
          value: ''
        }]
        question.displayConfig = question.displayConfig == '' ? {'displaySettingArr': []} : JSON.parse(question.displayConfig)
        question.jumpConfig = question.jumpConfig == '' ? {'jumpSettingArr': []} : JSON.parse(question.jumpConfig)
        question.displayNumber = question.displayNumber == '' ? [] : JSON.parse(question.displayNumber)
        question.scaleConfig = question.scaleConfig == '' ? [] : JSON.parse(question.scaleConfig)
        question.jumpNumber = question.jumpNumber == '' ? [] : JSON.parse(question.jumpNumber)
        question.dateCycle = this.getBoolean(question.dateCycle)
        question.isFirst = this.getBoolean(question.isFirst)
        question.isMust = this.getBoolean(question.isMust)
        question.isShow = this.getBoolean(question.isShow)
        question.manangerActive = this.getBoolean(question.manangerActive)
        question.seqDisabled = this.getBoolean(question.seqDisabled)
        question.paragraphConfig = question.paragraphConfig == '' ? '' : JSON.parse(question.paragraphConfig)
        question.manangerActive = false
        console.log(question.value);
        // question.value = question.value
        // if (question.answerInfo) {
        //   if (this.isJSON(question.answerInfo)) {
        //     question.value = JSON.parse(question.answerInfo)
        //     // question.isShow = true
        //   } else {
        //     question.value = question.answerInfo
        //     // question.isShow = true
        //   }
        // } else {
        //   question.value = ''
        // }
        question.options = question.optionsInfoRespList
      }
      //console.log(question)
      return question
    },
    isJSON(str) {
      //console.log(str)
      if (typeof str == 'string') {
        try {
          var obj = JSON.parse(str)
          if (typeof obj == 'object' && obj) {
            return true
          } else {
            return false
          }
        } catch (e) {
          return false
          //console.log('error：' + str + '!!!' + e)
        }
      }
      //console.log('It is not a string!')
    },
    getBoolean(num) {
      return num == 1 ? false : true
    },
    async getNextPage() {
      var errList = []
      for (var k in this.$refs) {
        if (this.$refs[k][0]) {
          //console.log(this.$refs[k][0].checkIsFill())
          if (Object.prototype.toString.call(this.$refs[k][0].checkIsFill()) === "[object Promise]") {
            var result
            result = await this.$refs[k][0].checkIsFill()
            if (!result) {
              await errList.push(this.$refs[k][0])
            }
          } else {
            if (!this.$refs[k][0].checkIsFill()) {
              //console.log(k)
              await errList.push(this.$refs[k][0])
            }
          }
        }
      }
      //console.log(errList)
      if (errList.length) {
        if (this.prevErrComponent) {
          this.prevErrComponent.style.border = '2px solid #fff'
        }
        this.prevErrComponent = errList[0].$el
        errList[0].$el.scrollIntoView()
        errList[0].$el.style.border = '2px dashed red'
        this.$message.error(errList[0].question.title + '填写不符合规范')
      } else {
        this.showList = false
        if (this.prevErrComponent) {
          this.prevErrComponent.style.border = '2px solid #fff'
        }
        this.getQuestionList({
          taskId: this.$route.query.id || this.questionId,
          pageNumber: this.nextPage
        })
        this.pageHistoryList.push(this.questionList[0].pageNumber)

        var promistList = []
        for (var k in this.$refs) {
          if (this.$refs[k][0]) {
            if (this.$refs[k][0].checkIsFill() && this.$refs[k][0].question.isShow) {
              promistList.push(this.$refs[k][0].saveAnswer())
            }
          }
        }
      }
    },
    async getPrevPage() {
      var deleteNumber = this.pageHistoryList.splice([this.pageHistoryList.length - 1], 1)
      this.$nextTick(() => {
        this.getQuestionList({
          taskId: this.$route.query.id || this.questionId,
          pageNumber: deleteNumber[0]
        })
      })
    },
    async getQuestionByPageAndId(p) {
      var vm = this
      let request = new RestNewFollowupQuestionListServicePreviewQuestionnaire()
      request.p_followUpType = vm.followUpWay;
      request.p_pageNumber = p.pageNumber;
      request.p_taskId = p.taskId;
      await request.send()
      console.log(request.result.retValue)
      return request.result
    },
    //保存答案
    async saveQuestionAnswer(p) {
      let request = new RestPatientAnswerInfoManagerControllerAddPatientAnswerInfo()
      request.p_answerInfo = p.answerInfo
      request.p_operatorId = p.operatorId
      request.p_questionInfo = p.questionInfo
      request.p_questionnaireNewId = p.questionnaireNewId
      request.p_questionType = p.questionType
      await request.send()
      return request.result
    },
    async getQuestionPage(p) {
      let request = new RestNewFollowupQuestionListServiceGetQuestionnairePageList()
      request.p_questionnaireNewId = this.questionnaireNewId
      await request.send()
      if (request.result.status == 0) {
        this.questionPageList = request.result.retValue
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.el-backtop {
  right: 1100px !important;
}
.fade-enter-active, .fade-leave-active {
  opacity: 1;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
{
  opacity: 0;
}

.cannotEditModel {
  width: 100%;
  height: 75%;
  background-color: rgba(0, 0, 0, .02);
  position: absolute;
  top: 0;
}

.container {
  display: flex;
  justify-content: space-between;

  .page {
    width: 15%;

    .page-item {
      padding: 10px 0;
    }

    .active {
      background-color: #ccc;
    }
  }

  .question-list {
  }
  .question {
    width: 85%;
    height: 100vh;
    overflow: auto;
  }
}

.btn-list {
  text-align: center;
  padding: 10px 0 20px;
}

.submitBtn {
  width: 30%;
  margin-right: .1 * 100px;
  background-color: #248cfa;
  color: #fff;
  padding: .05 * 100px 0;
  border: none;
  border-radius: .05 * 100px;
}

</style>
<style>
.qs-img-preview {
  max-width: 30%;
}
</style>
